// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customize the preview modal background */
.custom-preview .ant-image-preview-img {
    background-color: #f0f0f0; /* Add your desired background color */
    padding: 20px; /* Add padding to the image */
    border-radius: 8px; /* Optional: Rounded corners */
    display: inline-block; /* Ensure the background only covers the image */
  }
  
  /* Customize the modal itself (optional) */
  .custom-preview .ant-image-preview {
    background-color: rgba(0, 0, 0, 0.8); /* Modal overlay background */
  }
  `, "",{"version":3,"sources":["webpack://./src/views/lead/Lead.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;IACI,yBAAyB,EAAE,sCAAsC;IACjE,aAAa,EAAE,6BAA6B;IAC5C,kBAAkB,EAAE,8BAA8B;IAClD,qBAAqB,EAAE,gDAAgD;EACzE;;EAEA,0CAA0C;EAC1C;IACE,oCAAoC,EAAE,6BAA6B;EACrE","sourcesContent":["/* Customize the preview modal background */\n.custom-preview .ant-image-preview-img {\n    background-color: #f0f0f0; /* Add your desired background color */\n    padding: 20px; /* Add padding to the image */\n    border-radius: 8px; /* Optional: Rounded corners */\n    display: inline-block; /* Ensure the background only covers the image */\n  }\n  \n  /* Customize the modal itself (optional) */\n  .custom-preview .ant-image-preview {\n    background-color: rgba(0, 0, 0, 0.8); /* Modal overlay background */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
